__turbopack_context__.v({
  "className": "inter_e5387405-module__6kjfMG__className",
  "variable": "inter_e5387405-module__6kjfMG__variable",
});
